import React from 'react';
import { Routes, Route } from 'react-router-dom';
import { StartScreen } from '../components/start/StartScreen';
import { LoginScreen } from '../components/login/LoginScreen';
import { RegisterScreen } from '../components/register/RegisterScreen';


// DashboardRoute used to display Routes
export const DashboardPublicRoutes = () => {


    return (
        <Routes>
            <Route exact path="/" element={ <StartScreen/> } />
            <Route exact path="/login" element={ <LoginScreen/> } />
            <Route exact path="/registry" element={ <RegisterScreen/> } />
        </Routes>
    )
}
